import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import WorshipLocationsComponent from '../../components/WorshipLocations';
import { getWorshipLocationsRequest } from '../../actionCreators/worshipLocationsActions';
import { getUserOrganisationRequest } from '../../actionCreators/organisationActions';

const WorshipLocations = (props) => <WorshipLocationsComponent {...props} />;

const WorshipLocationsContainer = (props) => {
  const state = useSelector((state) => ({
    account: state.account,
    currentUser: state.currentUser,
    worshipLocations: state.worshipLocations.worshipLocationsList,
    customAppId: state.customApp.id,
    organisation: state.organisation.currentOrganisation,
  }));

  const dispatch = useDispatch();

  const actions = {
    getWorshipLocations: (payload) => dispatch(getWorshipLocationsRequest(payload)),
    getUserOrganisation: (payload) => dispatch(getUserOrganisationRequest(payload)),
  };

  return <WorshipLocations {...props} {...state} {...actions} />;
};

export default WorshipLocationsContainer;
